import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export const WidgetLineChart: Widget = {
    type: 'lineChart',
    id: 'line-chart',
    name: 'Line Chart - Legacy',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 2000,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.day },
                    INBOUND_MESSAGE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'snCTm',
                    },
                    PLATFORM: { source: ListeningDimensions.day, dimensionName: 'date' },
                    BENCHMARKING: { source: ListeningDimensions.day, dimensionName: 'date' },
                    PAID: {
                        source: ListeningDimensions.day,
                        dimensionName: 'measurementTime',
                    },
                    ADVOCACY: { source: ListeningDimensions.day, dimensionName: 'date' },
                    RDB_FIREHOSE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'SN_CREATED_TIME',
                    },
                    STORY_MESSAGE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'CREATED_TIME',
                    },
                    COMMUNITY: {
                        source: ListeningDimensions.dayOfWeek,
                        dimensionName: 'DAY_OF_WEEK',
                    },
                    SAM: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    AUDIENCE_ACTIVITY: {
                        source: ListeningDimensions.dayOfWeek,
                        dimensionName: 'DAY_OF_WEEK',
                    },
                }),
                new GroupBy({
                    LISTENING: {
                        source: ListeningDimensions.topicName,
                        limitType: 'TOP',
                        limit: 8,
                    },
                    INBOUND_MESSAGE: {
                        dimensionName: 'ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 8 },
                    BENCHMARKING: { dimensionName: 'BRAND_ID', limitType: 'TOP', limit: 8 },
                    PAID: { dimensionName: 'accountIds', limitType: 'TOP', limit: 8 },
                    ADVOCACY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'RDB_QUERY_IDS',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'RDB_DATA_SOURCE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    SAM: {
                        dimensionName: 'CLIENT_ID',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    AUDIENCE_ACTIVITY: {
                        dimensionName: 'ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 8,
                    },
                }),
            ],
            sorts: [new Sort({ order: 'DESC', projections: 0 })],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    label: {
        titleText: 'Line Chart',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    position: DefaultWidgetPosition,
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        showXAxis: true,
        xAxisTickAngle: 0,
        showYAxis: true,
        interpolation: 'linear',
        scaleType: 'linear',
        showTopPointMarker: false,
        showTopPointLabel: true,
        showTopPointValue: true,
        showTopPointIcon: true,
        showTopPointOrb: true,
        showPointMarkers: false,
        labelSize: 12,
        valueSize: 60,
        iconSize: 10,
        orbSize: 10,
        maxTopPoints: 10,
        lineWidth: 5,
        channelColoredStroke: true,
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
};
